{
    "Absenden": "Absenden",
    "Bitte prüfe den Link oder frag deine Gastgeber nach einem neuen.": "Bitte prüfe den Link oder frag deine Gastgeber nach einem neuen.",
    "ca. {seconds} Sek.": "ca. {seconds} Sek.",
    "Danke für dein Feedback!": "Danke für dein Feedback!",
    "Danke trotzdem, dass du dir Zeit nehmen wolltest!": "Danke trotzdem, dass du dir Zeit nehmen wolltest!",
    "Danke, dein Feedback ist schon angekommen": "Danke, dein Feedback ist schon angekommen",
    "Dein Kommentar (optional)": "Dein Kommentar (optional)",
    "Deine Antworten helfen deinen Gastgebern, noch besser zu werden.": "Deine Antworten helfen deinen Gastgebern, noch besser zu werden.",
    "Deine Antworten helfen {house}, noch besser zu werden.": "Deine Antworten helfen {house}, noch besser zu werden.",
    "Deine Antworten sind für den Gastgeber anonym.": "Deine Antworten sind für den Gastgeber anonym.",
    "Deine Antworten sind gespeichert und werden gesendet, sobald du wieder online bist.": "Deine Antworten sind gespeichert und werden gesendet, sobald du wieder online bist.",
    "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei.": "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei.",
    "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung.": "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung.",
    "Diese Umfrage ist nicht mehr verfügbar": "Diese Umfrage ist nicht mehr verfügbar",
    "Dieser Link ist ungültig": "Dieser Link ist ungültig",
    "Erneut versuchen": "Erneut versuchen",
    "Fast oben …": "Fast oben …",
    "Feedback geben": "Feedback geben",
    "Fortschritt": "Fortschritt",
    "Geht so": "Geht so",
    "Gerade gibt es keine Umfrage": "Gerade gibt es keine Umfrage",
    "Gipfelstürmer": "Gipfelstürmer",
    "Gut": "Gut",
    "Ja": "Ja",
    "Ja, etwas schreiben": "Ja, etwas schreiben",
    "Keine Verbindung": "Keine Verbindung",
    "Mehrfachauswahl möglich": "Mehrfachauswahl möglich",
    "Nein": "Nein",
    "Nein, fertig": "Nein, fertig",
    "Nein, weiter": "Nein, weiter",
    "Noch {count} Fragen": {
        "one": "Noch 1 Frage",
        "other": "Noch {n} Fragen"
    },
    "Schlecht": "Schlecht",
    "Sehr gut": "Sehr gut",
    "Sehr schlecht": "Sehr schlecht",
    "sehr wahrscheinlich": "sehr wahrscheinlich",
    "Umfrage wird geladen …": "Umfrage wird geladen …",
    "unwahrscheinlich": "unwahrscheinlich",
    "Zur Gäste-App": "Zur Gäste-App",
    "Zurück zur App": "Zurück zur App",
    "{value} von 5": "{value} von 5",
    "„{name}“ und alle Einträge darin werden entfernt. Das lässt sich nicht rückgängig machen.": "„{name}“ und alle Einträge darin werden entfernt. Das lässt sich nicht rückgängig machen.",
    "{count} Adressen in der Nähe": {
        "one": "1 Adresse in der Nähe",
        "other": "{n} Adressen in der Nähe"
    },
    "{count} Einträge liegen außerhalb des neuen Zeitraums und sind jetzt wieder ohne Tag.": {
        "one": "Ein Eintrag liegt außerhalb des neuen Zeitraums und ist jetzt wieder ohne Tag.",
        "other": "{n} Einträge liegen außerhalb des neuen Zeitraums und sind jetzt wieder ohne Tag."
    },
    "{count} Nächte": {
        "one": "1 Nacht",
        "other": "{n} Nächte"
    },
    "{count} Orte in der Nähe": {
        "one": "1 Ort in der Nähe",
        "other": "{n} Orte in der Nähe"
    },
    "{count} Tipps deiner Gastgeber": {
        "one": "1 Tipp deiner Gastgeber",
        "other": "{n} Tipps deiner Gastgeber"
    },
    "{count} Touren in der Nähe": {
        "one": "1 Tour in der Nähe",
        "other": "{n} Touren in der Nähe"
    },
    "{count}-Tage-Vorhersage": "{count}-Tage-Vorhersage",
    "{day} · {time} Uhr": "{day} · {time} Uhr",
    "{day} · ganztägig": "{day} · ganztägig",
    "{day}. {mon} · {time} Uhr": "{day}. {mon} · {time} Uhr",
    "{feature} gehört zu dir, nicht zum Haus — deine Auswahl und deine Nachrichten bleiben erhalten, wenn du ein Konto anlegst. Alles andere in der App kannst du weiterhin ohne Konto nutzen.": "{feature} gehört zu dir, nicht zum Haus — deine Auswahl und deine Nachrichten bleiben erhalten, wenn du ein Konto anlegst. Alles andere in der App kannst du weiterhin ohne Konto nutzen.",
    "{feature} ist bald verfügbar.": "{feature} ist bald verfügbar.",
    "{feature} steht dir zur Verfügung, sobald deine E-Mail-Adresse bestätigt ist. Öffne dazu den Link, den wir dir geschickt haben.": "{feature} steht dir zur Verfügung, sobald deine E-Mail-Adresse bestätigt ist. Öffne dazu den Link, den wir dir geschickt haben.",
    "{from}–{to} Uhr": "{from}–{to} Uhr",
    "{label} & Gewitter": "{label} & Gewitter",
    "{list} & mehr": "{list} & mehr",
    "{n} hm Aufstieg": "{n} hm Aufstieg",
    "{n} km": "{n} km",
    "{n} m": "{n} m",
    "{speed} aus {compass}": "{speed} aus {compass}",
    "{time} Uhr": "{time} Uhr",
    "{title} zum Planer hinzufügen": "{title} zum Planer hinzufügen",
    "10 – 21 Uhr": "10 – 21 Uhr",
    "25 Min": "25 Min",
    "50 Min": "50 Min",
    "60 Min": "60 Min",
    "7 Tage": "7 Tage",
    "7 Tage & Details": "7 Tage & Details",
    "80 Min": "80 Min",
    "Ab {age} Jahren": "Ab {age} Jahren",
    "ab {amount}": "ab {amount}",
    "ab {from} Uhr": "ab {from} Uhr",
    "Abbrechen": "Abbrechen",
    "abgesagt": "abgesagt",
    "Abmelden": "Abmelden",
    "Abreise": "Abreise",
    "AGB": "AGB",
    "Aktualisiert {time} Uhr": "Aktualisiert {time} Uhr",
    "Aktuell nichts geplant": "Aktuell nichts geplant",
    "Alle": "Alle",
    "Alle ausklappen": "Alle ausklappen",
    "Alle einklappen": "Alle einklappen",
    "Alle Empfehlungen": "Alle Empfehlungen",
    "Alle Events": "Alle Events",
    "Alles eingeplant. Neue Favoriten landen hier.": "Alles eingeplant. Neue Favoriten landen hier.",
    "Alles klar": "Alles klar",
    "Alles zeigen": "Alles zeigen",
    "Als Gast angemeldet": "Als Gast angemeldet",
    "Als Gast fortfahren": "Als Gast fortfahren",
    "Als Nächstes": "Als Nächstes",
    "Am Haus": "Am Haus",
    "Änderungen speichern": "Änderungen speichern",
    "Anmelden": "Anmelden",
    "Anmeldung erforderlich": "Anmeldung erforderlich",
    "Anmeldung fehlgeschlagen. Du kannst auch als Gast fortfahren.": "Anmeldung fehlgeschlagen. Du kannst auch als Gast fortfahren.",
    "Anreise": "Anreise",
    "Ansehen": "Ansehen",
    "Architektur": "Architektur",
    "Auf die Tage verteilen": "Auf die Tage verteilen",
    "Aufenthalt": "Aufenthalt",
    "Aufguss-Zeremonie": "Aufguss-Zeremonie",
    "Aus dem Planer entfernt.": "Aus dem Planer entfernt.",
    "Aussichtspunkt": "Aussichtspunkt",
    "ausverkauft": "ausverkauft",
    "Ausverkauft": "Ausverkauft",
    "Bäckerei": "Bäckerei",
    "Bad & Badestelle": "Bad & Badestelle",
    "Bar": "Bar",
    "Barrierefrei zugänglich": "Barrierefrei zugänglich",
    "Behandlungen": "Behandlungen",
    "Berghütte": "Berghütte",
    "bestätigt": "bestätigt",
    "Bewölkt": "Bewölkt",
    "Bewölkung": "Bewölkung",
    "Biergarten": "Biergarten",
    "Bild {i} von {total} vergrößern": "Bild {i} von {total} vergrößern",
    "Bild vergrößern": "Bild vergrößern",
    "Bilder": "Bilder",
    "Bitte bestätige deine E-Mail": "Bitte bestätige deine E-Mail",
    "Bitte gib dein Passwort ein.": "Bitte gib dein Passwort ein.",
    "Bitte gib deinem Reiseplan einen Namen.": "Bitte gib deinem Reiseplan einen Namen.",
    "Bitte gib deinen Namen ein.": "Bitte gib deinen Namen ein.",
    "Bitte gib den Zeitraum deiner Reise an.": "Bitte gib den Zeitraum deiner Reise an.",
    "Bitte gib eine gültige E-Mail-Adresse ein.": "Bitte gib eine gültige E-Mail-Adresse ein.",
    "Bitte schreib zuerst eine Nachricht.": "Bitte schreib zuerst eine Nachricht.",
    "Bitte überprüfe deine Eingaben.": "Bitte überprüfe deine Eingaben.",
    "Bitte versuche es später erneut.": "Bitte versuche es später erneut.",
    "Böen": "Böen",
    "Bootsverleih": "Bootsverleih",
    "Brauerei": "Brauerei",
    "Bücherei": "Bücherei",
    "Burg & Schloss": "Burg & Schloss",
    "ca. {duration}": "ca. {duration}",
    "Café": "Café",
    "Chat": "Chat",
    "Check-in / Check-out": "Check-in / Check-out",
    "Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.": "Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.",
    "Check-out": "Check-out",
    "Club": "Club",
    "da bist.": "da bist.",
    "Dafür brauchst du ein Konto": "Dafür brauchst du ein Konto",
    "Dafür fehlt dir die Berechtigung. Melde dich neu an.": "Dafür fehlt dir die Berechtigung. Melde dich neu an.",
    "Das dauert nur einen Augenblick.": "Das dauert nur einen Augenblick.",
    "Das geht nicht mehr — du hast das Maximum erreicht.": "Das geht nicht mehr — du hast das Maximum erreicht.",
    "Das hat nicht": "Das hat nicht",
    "Das Passwort braucht mindestens 8 Zeichen.": "Das Passwort braucht mindestens 8 Zeichen.",
    "Das Wetter ist gerade nicht verfügbar.": "Das Wetter ist gerade nicht verfügbar.",
    "Datenschutz": "Datenschutz",
    "Dauert unter einer Minute.": "Dauert unter einer Minute.",
    "Dein Aufenthalt": "Dein Aufenthalt",
    "Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.": "Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.",
    "Dein Gastgeber": "Dein Gastgeber",
    "Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.": "Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.",
    "Dein Gastgeber, {name}": "Dein Gastgeber, {name}",
    "Dein Planer": "Dein Planer",
    "Deine E-Mail-Adresse ist bestätigt.": "Deine E-Mail-Adresse ist bestätigt.",
    "Deine Gastgeber": "Deine Gastgeber",
    "Deine Gastgeber haben hier noch nichts empfohlen.": "Deine Gastgeber haben hier noch nichts empfohlen.",
    "Deine Region,": "Deine Region,",
    "Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.": "Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.",
    "deinem Gastgeber": "deinem Gastgeber",
    "deiner Gastgeber": "deiner Gastgeber",
    "Denkmal": "Denkmal",
    "Der Chat": "Der Chat",
    "Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.": "Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.",
    "Der Eintrag konnte nicht entfernt werden.": "Der Eintrag konnte nicht entfernt werden.",
    "Der Eintrag konnte nicht hinzugefügt werden.": "Der Eintrag konnte nicht hinzugefügt werden.",
    "Der Eintrag konnte nicht verschoben werden.": "Der Eintrag konnte nicht verschoben werden.",
    "Der Reiseplan konnte nicht erstellt werden.": "Der Reiseplan konnte nicht erstellt werden.",
    "Der Reiseplan konnte nicht gelöscht werden.": "Der Reiseplan konnte nicht gelöscht werden.",
    "Der Reiseplan konnte nicht geöffnet werden.": "Der Reiseplan konnte nicht geöffnet werden.",
    "Der Reiseplan konnte nicht gespeichert werden.": "Der Reiseplan konnte nicht gespeichert werden.",
    "Details": "Details",
    "Die Abreise kann nicht vor der Anreise liegen.": "Die Abreise kann nicht vor der Anreise liegen.",
    "Die Empfehlungen konnten nicht geladen werden.": "Die Empfehlungen konnten nicht geladen werden.",
    "Die Empfehlungen konnten nicht geladen werden. Bitte versuche es später noch einmal.": "Die Empfehlungen konnten nicht geladen werden. Bitte versuche es später noch einmal.",
    "Die Karte konnte nicht geladen werden.": "Die Karte konnte nicht geladen werden.",
    "Die Nachricht konnte nicht gesendet werden.": "Die Nachricht konnte nicht gesendet werden.",
    "Die Registrierung hat nicht geklappt. Bitte versuche es später erneut.": "Die Registrierung hat nicht geklappt. Bitte versuche es später erneut.",
    "Die Reihenfolge konnte nicht gespeichert werden.": "Die Reihenfolge konnte nicht gespeichert werden.",
    "Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.": "Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.",
    "Diese Funktion ist bald verfügbar.": "Diese Funktion ist bald verfügbar.",
    "Diese Nachricht ist zu lang.": "Diese Nachricht ist zu lang.",
    "Diese Unterkunft ist noch nicht freigeschaltet — Empfehlungen aus der Region erscheinen hier, sobald sie es ist.": "Diese Unterkunft ist noch nicht freigeschaltet — Empfehlungen aus der Region erscheinen hier, sobald sie es ist.",
    "Dieser Bereich": "Dieser Bereich",
    "Dieser Chat ist nicht mehr verfügbar.": "Dieser Chat ist nicht mehr verfügbar.",
    "Dieser Eintrag ist nicht mehr verfügbar.": "Dieser Eintrag ist nicht mehr verfügbar.",
    "Dieser Link ist unvollständig.": "Dieser Link ist unvollständig.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig. Versuche dich anzumelden — dein Konto ist möglicherweise schon aktiv.": "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig. Versuche dich anzumelden — dein Konto ist möglicherweise schon aktiv.",
    "Direkt verbunden": "Direkt verbunden",
    "Download": "Download",
    "Du kannst dich jetzt anmelden und deine Gästemappe nutzen.": "Du kannst dich jetzt anmelden und deine Gästemappe nutzen.",
    "E-Mail": "E-Mail",
    "E-Mail bestätigen": "E-Mail bestätigen",
    "E-Mail noch nicht bestätigt": "E-Mail noch nicht bestätigt",
    "Ein Reiseplan kann höchstens 60 Tage umfassen.": "Ein Reiseplan kann höchstens 60 Tage umfassen.",
    "Einen Moment …": "Einen Moment …",
    "Einstellungen": "Einstellungen",
    "Eintritt auf Spendenbasis": "Eintritt auf Spendenbasis",
    "Eintritt frei": "Eintritt frei",
    "Eisdiele": "Eisdiele",
    "Empfehlungen": "Empfehlungen",
    "Empfehlungen für deinen Zeitraum": "Empfehlungen für deinen Zeitraum",
    "Empfehlungen für dich": "Empfehlungen für dich",
    "Endgültig löschen": "Endgültig löschen",
    "Entdecken": "Entdecken",
    "entdeckt.": "entdeckt.",
    "Entfernen": "Entfernen",
    "Erstmal ohne Konto ansehen": "Erstmal ohne Konto ansehen",
    "Events": "Events",
    "Events & Erlebnisse": "Events & Erlebnisse",
    "Fast geschafft": "Fast geschafft",
    "Favoriten sammeln": "Favoriten sammeln",
    "Findet draußen statt": "Findet draußen statt",
    "Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.": "Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.",
    "frei nutzbar": "frei nutzbar",
    "Frühling": "Frühling",
    "Führung": "Führung",
    "Für den Chat brauchst du ein bestätigtes Konto.": "Für den Chat brauchst du ein bestätigtes Konto.",
    "Für die nächsten Stunden liegt keine Vorhersage vor.": "Für die nächsten Stunden liegt keine Vorhersage vor.",
    "Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.": "Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.",
    "Für diese E-Mail-Adresse gibt es schon ein Konto. Bitte melde dich stattdessen an.": "Für diese E-Mail-Adresse gibt es schon ein Konto. Bitte melde dich stattdessen an.",
    "Für diese Kategorie gibt es hier noch keine Einträge.": "Für diese Kategorie gibt es hier noch keine Einträge.",
    "Für diese Unterkunft ist der Planer nicht verfügbar.": "Für diese Unterkunft ist der Planer nicht verfügbar.",
    "Für diese Unterkunft ist keine Kartenquelle hinterlegt.": "Für diese Unterkunft ist keine Kartenquelle hinterlegt.",
    "Für Familien geeignet": "Für Familien geeignet",
    "Für Hausgäste": "Für Hausgäste",
    "Galerie": "Galerie",
    "ganztägig": "ganztägig",
    "Gast": "Gast",
    "Gästemappe": "Gästemappe",
    "Gastgeber": "Gastgeber",
    "Gastgeber fragen": "Gastgeber fragen",
    "Gastronomie": "Gastronomie",
    "Gehört zu deinem Aufenthalt": "Gehört zu deinem Aufenthalt",
    "geklappt": "geklappt",
    "Gelesen": "Gelesen",
    "Geotop": "Geotop",
    "Geschäft": "Geschäft",
    "geschlossen": "geschlossen",
    "Gesichtsbehandlung Natur": "Gesichtsbehandlung Natur",
    "Gestern": "Gestern",
    "Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.": "Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.",
    "GPX-Track laden": "GPX-Track laden",
    "Gut zu wissen": "Gut zu wissen",
    "Habt ihr einen Tipp für heute Abend?": "Habt ihr einen Tipp für heute Abend?",
    "Hallo {name},": "Hallo {name},",
    "Häufige Fragen": "Häufige Fragen",
    "Hauptnavigation": "Hauptnavigation",
    "Heiter": "Heiter",
    "Herbst": "Herbst",
    "Herzlich willkommen —": "Herzlich willkommen —",
    "Heute": "Heute",
    "Heute {hours}": "Heute {hours}",
    "Heute geschlossen": "Heute geschlossen",
    "Heute im Detail": "Heute im Detail",
    "Hin und zurück": "Hin und zurück",
    "Hinzufügen": "Hinzufügen",
    "Historische Stätte": "Historische Stätte",
    "Historischer Kern": "Historischer Kern",
    "Hofladen": "Hofladen",
    "Höhle": "Höhle",
    "Home": "Home",
    "Hunde erlaubt": "Hunde erlaubt",
    "Ich akzeptiere die": "Ich akzeptiere die",
    "Im Freien": "Im Freien",
    "Impressum": "Impressum",
    "In der Region": "In der Region",
    "In dieser Auswahl steht gerade nichts an.": "In dieser Auswahl steht gerade nichts an.",
    "inkl.": "inkl.",
    "Jetzt": "Jetzt",
    "Kanutour": "Kanutour",
    "Karte": "Karte",
    "Kein Download nötig — die App lebt in deinem Browser.": "Kein Download nötig — die App lebt in deinem Browser.",
    "Kein Konto mit dieser E-Mail-Adresse gefunden.": "Kein Konto mit dieser E-Mail-Adresse gefunden.",
    "Kinderwagentauglich": "Kinderwagentauglich",
    "Kino": "Kino",
    "Kirche": "Kirche",
    "Klar": "Klar",
    "Klassische Rückenmassage": "Klassische Rückenmassage",
    "Klettertour": "Klettertour",
    "Kloster": "Kloster",
    "Können wir später einchecken?": "Können wir später einchecken?",
    "Konto": "Konto",
    "Konto erstellen": "Konto erstellen",
    "Kräuterstempel-Massage": "Kräuterstempel-Massage",
    "Langlaufloipe": "Langlaufloipe",
    "Laufstrecke": "Laufstrecke",
    "Leicht": "Leicht",
    "Leichte Schauer": "Leichte Schauer",
    "Leichte Schneeregenschauer": "Leichte Schneeregenschauer",
    "Leichte Schneeschauer": "Leichte Schneeschauer",
    "Leichter Regen": "Leichter Regen",
    "Leichter Schneefall": "Leichter Schneefall",
    "Leichter Schneeregen": "Leichter Schneeregen",
    "Letzter Schritt": "Letzter Schritt",
    "Link ungültig": "Link ungültig",
    "Liste": "Liste",
    "Los geht's": "Los geht's",
    "Löschen": "Löschen",
    "Luftdruck": "Luftdruck",
    "Luftfeuchte": "Luftfeuchte",
    "Mehr": "Mehr",
    "Mehr erfahren": "Mehr erfahren",
    "Mein Planer": "Mein Planer",
    "Mein Reiseplan": "Mein Reiseplan",
    "Meine Buchungen": "Meine Buchungen",
    "Meine Reise · {house}": "Meine Reise · {house}",
    "Menü": "Menü",
    "Menü öffnen": "Menü öffnen",
    "Menü schließen": "Menü schließen",
    "Merken": "Merken",
    "Mindestens 8 Zeichen": "Mindestens 8 Zeichen",
    "Mittel": "Mittel",
    "Morgen": "Morgen",
    "Mountainbike": "Mountainbike",
    "Mühle": "Mühle",
    "Museum": "Museum",
    "N": "N",
    "Nach oben": "Nach oben",
    "Nach unten": "Nach unten",
    "Nachname": "Nachname",
    "Nachricht schreiben …": "Nachricht schreiben …",
    "Nächstes Bild": "Nächstes Bild",
    "Name deines Reiseplans": "Name deines Reiseplans",
    "Name und Zeitraum deiner Reise.": "Name und Zeitraum deiner Reise.",
    "Natur": "Natur",
    "Naturinformation": "Naturinformation",
    "Nebel": "Nebel",
    "Neuen Link anfordern": "Neuen Link anfordern",
    "Neuen Reiseplan anlegen": "Neuen Reiseplan anlegen",
    "Nicht mehr verfügbar": "Nicht mehr verfügbar",
    "Nichts angekommen? Sieh auch im Spam-Ordner nach.": "Nichts angekommen? Sieh auch im Spam-Ordner nach.",
    "Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.": "Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.",
    "Niederschlag": "Niederschlag",
    "NNO": "NNO",
    "NNW": "NNW",
    "NO": "NO",
    "Noch kein Konto?": "Noch kein Konto?",
    "Noch kein Reiseplan": "Noch kein Reiseplan",
    "Notfallkontakte": "Notfallkontakte",
    "Nur das Nötigste — in unter einer Minute fertig.": "Nur das Nötigste — in unter einer Minute fertig.",
    "NW": "NW",
    "O": "O",
    "oder": "oder",
    "Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.": "Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.",
    "Öffnungszeiten": "Öffnungszeiten",
    "ONO": "ONO",
    "Ort wird noch bekannt gegeben": "Ort wird noch bekannt gegeben",
    "OSO": "OSO",
    "Park & Garten": "Park & Garten",
    "Parkmöglichkeit": "Parkmöglichkeit",
    "Passwort": "Passwort",
    "Passwort anzeigen": "Passwort anzeigen",
    "Passwort verbergen": "Passwort verbergen",
    "Passwort vergessen?": "Passwort vergessen?",
    "Pilgerweg": "Pilgerweg",
    "Plane deine Reise — Tag für Tag.": "Plane deine Reise — Tag für Tag.",
    "Planer": "Planer",
    "Radtour": "Radtour",
    "Regen": "Regen",
    "Regenschauer": "Regenschauer",
    "Region": "Region",
    "Region-Tipps": "Region-Tipps",
    "Regionale Vorhersage für {place}.": "Regionale Vorhersage für {place}.",
    "Regionale Vorhersage.": "Regionale Vorhersage.",
    "Registrieren": "Registrieren",
    "Reiseplan angelegt.": "Reiseplan angelegt.",
    "Reiseplan anlegen": "Reiseplan anlegen",
    "Reiseplan bearbeiten": "Reiseplan bearbeiten",
    "Reiseplan erstellen": "Reiseplan erstellen",
    "Reiseplan gelöscht.": "Reiseplan gelöscht.",
    "Reiseplan gespeichert.": "Reiseplan gespeichert.",
    "Reiseplan löschen": "Reiseplan löschen",
    "Reiseplan löschen?": "Reiseplan löschen?",
    "Reiseplan wählen": "Reiseplan wählen",
    "Reittour": "Reittour",
    "Rennrad": "Rennrad",
    "Reservierung erforderlich": "Reservierung erforderlich",
    "Restaurant": "Restaurant",
    "Restaurants": "Restaurants",
    "Restaurants, Sehenswürdigkeiten und Touren in deiner Nähe — als Liste oder auf der Karte.": "Restaurants, Sehenswürdigkeiten und Touren in deiner Nähe — als Liste oder auf der Karte.",
    "Route starten": "Route starten",
    "Ruine": "Ruine",
    "Rundweg": "Rundweg",
    "S": "S",
    "Sächsische Schweiz": "Sächsische Schweiz",
    "Sammle alles, was dich interessiert, und ordne deine Tage so, wie es dir passt.": "Sammle alles, was dich interessiert, und ordne deine Tage so, wie es dir passt.",
    "Sauna & Pool": "Sauna & Pool",
    "Schließen": "Schließen",
    "Schneefall": "Schneefall",
    "Schneeregen": "Schneeregen",
    "Schneeregenschauer": "Schneeregenschauer",
    "Schneeschauer": "Schneeschauer",
    "Schneeschuhtour": "Schneeschuhtour",
    "Schnellzugriff": "Schnellzugriff",
    "schön dass du da bist.": "schön dass du da bist.",
    "Schon registriert?": "Schon registriert?",
    "Schön, dass du": "Schön, dass du",
    "schön, dass du da bist.": "schön, dass du da bist.",
    "Schreib deinen Gastgebern": "Schreib deinen Gastgebern",
    "Schreib deinen Gastgebern jederzeit — oder frag den Concierge, wenn es schnell gehen soll.": "Schreib deinen Gastgebern jederzeit — oder frag den Concierge, wenn es schnell gehen soll.",
    "Schreib uns – wir antworten schnell.": "Schreib uns – wir antworten schnell.",
    "Schritt {step} von {total}": "Schritt {step} von {total}",
    "Schwer": "Schwer",
    "See": "See",
    "Sehenswertes": "Sehenswertes",
    "Sehenswürdigkeit": "Sehenswürdigkeit",
    "Sehenswürdigkeiten": "Sehenswürdigkeiten",
    "Sehr schwer": "Sehr schwer",
    "Senden": "Senden",
    "Services": "Services",
    "SO": "SO",
    "So. 11:00 Uhr": "So. 11:00 Uhr",
    "Sommer": "Sommer",
    "Sonnig": "Sonnig",
    "Sonstiges": "Sonstiges",
    "Spa & Wellness": "Spa & Wellness",
    "Spaziergang": "Spaziergang",
    "Spielplatz": "Spielplatz",
    "Sport": "Sport",
    "Sprache": "Sprache",
    "SSO": "SSO",
    "SSW": "SSW",
    "Stadtrundgang": "Stadtrundgang",
    "Starke Schauer": "Starke Schauer",
    "Starke Schneeregenschauer": "Starke Schneeregenschauer",
    "Starke Schneeschauer": "Starke Schneeschauer",
    "Starker Regen": "Starker Regen",
    "Starker Schneefall": "Starker Schneefall",
    "Starker Schneeregen": "Starker Schneeregen",
    "Steht schon in deinem Planer.": "Steht schon in deinem Planer.",
    "Streckentour": "Streckentour",
    "Stündlich": "Stündlich",
    "SW": "SW",
    "Tag {n}": "Tag {n}",
    "Tagesplanung": "Tagesplanung",
    "Taupunkt": "Taupunkt",
    "Teilen": "Teilen",
    "Teilen nicht möglich.": "Teilen nicht möglich.",
    "Teils bewölkt": "Teils bewölkt",
    "Termin anfragen": "Termin anfragen",
    "Termin buchen": "Termin buchen",
    "Termin folgt": "Termin folgt",
    "Theater & Bühne": "Theater & Bühne",
    "Ticket erforderlich": "Ticket erforderlich",
    "Tickets": "Tickets",
    "Tipps & Events aus der Region erhalten": "Tipps & Events aus der Region erhalten",
    "Tour": "Tour",
    "Touren": "Touren",
    "Tourist-Information": "Tourist-Information",
    "Überspringen": "Überspringen",
    "UV-Index": "UV-Index",
    "Veranstaltung": "Veranstaltung",
    "Veranstaltungen": "Veranstaltungen",
    "Veranstaltungen nicht verfügbar": "Veranstaltungen nicht verfügbar",
    "Veranstaltungsort": "Veranstaltungsort",
    "Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.": "Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.",
    "Vergrößern": "Vergrößern",
    "Verkehr": "Verkehr",
    "Verkleinern": "Verkleinern",
    "Verschieben": "Verschieben",
    "Verstanden": "Verstanden",
    "Vom Haus": "Vom Haus",
    "Vorheriges Bild": "Vorheriges Bild",
    "Vorhersage": "Vorhersage",
    "Vorname": "Vorname",
    "W": "W",
    "Wanderung": "Wanderung",
    "Wann gibt es Frühstück?": "Wann gibt es Frühstück?",
    "Was dich erwartet": "Was dich erwartet",
    "Wasserfall": "Wasserfall",
    "WC": "WC",
    "Weinabend, Sonnenaufgangstour, Konzert im Fels — alles im Haus und in der Region, mit einem Tipp gebucht.": "Weinabend, Sonnenaufgangstour, Konzert im Fels — alles im Haus und in der Region, mit einem Tipp gebucht.",
    "Weingut": "Weingut",
    "Weiter": "Weiter",
    "Weitere Termine": "Weitere Termine",
    "Wellness & Sauna": "Wellness & Sauna",
    "Wetter": "Wetter",
    "Wetter nicht verfügbar": "Wetter nicht verfügbar",
    "Wetter und Vorhersage": "Wetter und Vorhersage",
    "Wetter wird geladen …": "Wetter wird geladen …",
    "Wetterdaten:": "Wetterdaten:",
    "Willkommen": "Willkommen",
    "Willkommen zurück": "Willkommen zurück",
    "Wind": "Wind",
    "Winter": "Winter",
    "Winterwanderung": "Winterwanderung",
    "Wir haben dir eine Nachricht geschickt.": "Wir haben dir eine Nachricht geschickt.",
    "Wir haben dir einen Bestätigungslink geschickt. Öffne ihn, damit dein Konto vollständig aktiv ist. Bis dahin kannst du die App schon nutzen.": "Wir haben dir einen Bestätigungslink geschickt. Öffne ihn, damit dein Konto vollständig aktiv ist. Bis dahin kannst du die App schon nutzen.",
    "Wir konnten deinen Link nicht bestätigen.": "Wir konnten deinen Link nicht bestätigen.",
    "Wir melden uns mit einem Terminvorschlag.": "Wir melden uns mit einem Terminvorschlag.",
    "Wir prüfen deinen Bestätigungslink.": "Wir prüfen deinen Bestätigungslink.",
    "Wird geladen …": "Wird geladen …",
    "WLAN, Frühstück, Check-out & mehr": "WLAN, Frühstück, Check-out & mehr",
    "WNW": "WNW",
    "WSW": "WSW",
    "z. B. Wochenende in der Sächsischen Schweiz": "z. B. Wochenende in der Sächsischen Schweiz",
    "Zeitraum festlegen": "Zeitraum festlegen",
    "Zieh eine Attraktion hierher.": "Zieh eine Attraktion hierher.",
    "Zimmerservice": "Zimmerservice",
    "Zoo & Tierpark": "Zoo & Tierpark",
    "Zu diesen Einträgen sind keine Koordinaten hinterlegt.": "Zu diesen Einträgen sind keine Koordinaten hinterlegt.",
    "Zugang verweigert. Prüfe deine Zugangsdaten.": "Zugang verweigert. Prüfe deine Zugangsdaten.",
    "Zum Planer hinzufügen": "Zum Planer hinzufügen",
    "Zur Anmeldung": "Zur Anmeldung",
    "Zur Website": "Zur Website",
    "Zurück": "Zurück",
    "App zum Home-Bildschirm hinzufügen": "App zum Home-Bildschirm hinzufügen",
    "Tippe auf „Teilen“ (Quadrat mit Pfeil nach oben — in Safari unten, in anderen Browsern oben) und wähle „Zum Home-Bildschirm“. Danach öffnest du die App direkt von dort — ohne Browserleiste.": "Tippe auf „Teilen“ (Quadrat mit Pfeil nach oben — in Safari unten, in anderen Browsern oben) und wähle „Zum Home-Bildschirm“. Danach öffnest du die App direkt von dort — ohne Browserleiste.",
    "Installieren": "Installieren",
    "Neue Version der Gäste-App verfügbar.": "Neue Version der Gäste-App verfügbar.",
    "Aktualisieren": "Aktualisieren",
    "Keine Verbindung — du siehst die zuletzt geladenen Inhalte.": "Keine Verbindung — du siehst die zuletzt geladenen Inhalte.",
    "Link kopiert.": "Link kopiert.",
    "App installieren": "App installieren",
    "Der Bildschirm kann gerade nicht angelassen werden.": "Der Bildschirm kann gerade nicht angelassen werden.",
    "An": "An",
    "Aus": "Aus",
    "Bildschirm anlassen, solange du der Tour folgst": "Bildschirm anlassen, solange du der Tour folgst",
    "Als App auf den Home-Bildschirm — auch offline nutzbar.": "Als App auf den Home-Bildschirm — auch offline nutzbar.",
    "Concierge": "Concierge",
    "KI-Concierge · {house}": "KI-Concierge · {house}",
    "Das hat nicht geklappt. Bitte versuch es noch einmal.": "Das hat nicht geklappt. Bitte versuch es noch einmal.",
    "Direkt an {name} schreiben": "Direkt an {name} schreiben",
    "Concierge fragen": "Concierge fragen",
    "Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.": "Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.",
    "Soll ich das an {name} weitergeben?": "Soll ich das an {name} weitergeben?",
    "Ja, weitergeben": "Ja, weitergeben",
    "Nein, danke": "Nein, danke",
    "Der Concierge schreibt …": "Der Concierge schreibt …",
    "Frag den Concierge …": "Frag den Concierge …",
    "Der Concierge ist gerade nicht erreichbar. Mit einem bestätigten Konto kannst du deinen Gastgebern direkt schreiben.": "Der Concierge ist gerade nicht erreichbar. Mit einem bestätigten Konto kannst du deinen Gastgebern direkt schreiben.",
    "Du schreibst jetzt direkt mit {name}. Die Antwort kommt hier.": "Du schreibst jetzt direkt mit {name}. Die Antwort kommt hier.",
    "Der Concierge antwortet wieder. Deine Gastgeber lesen weiter mit.": "Der Concierge antwortet wieder. Deine Gastgeber lesen weiter mit.",
    "Der Concierge ist gerade nicht verfügbar. Deine Nachricht ist bei {name} angekommen — die Antwort kommt hier.": "Der Concierge ist gerade nicht verfügbar. Deine Nachricht ist bei {name} angekommen — die Antwort kommt hier.",
    "Dein Name wurde gespeichert.": "Dein Name wurde gespeichert.",
    "Dein Name konnte nicht gespeichert werden. Bitte versuche es später erneut.": "Dein Name konnte nicht gespeichert werden. Bitte versuche es später erneut.",
    "Bitte gib dein aktuelles Passwort ein.": "Bitte gib dein aktuelles Passwort ein.",
    "Das neue Passwort muss sich vom aktuellen unterscheiden.": "Das neue Passwort muss sich vom aktuellen unterscheiden.",
    "Die Passwörter stimmen nicht überein.": "Die Passwörter stimmen nicht überein.",
    "Dein Passwort wurde geändert.": "Dein Passwort wurde geändert.",
    "Das aktuelle Passwort stimmt nicht.": "Das aktuelle Passwort stimmt nicht.",
    "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.",
    "Dein Konto": "Dein Konto",
    "Du nutzt die App ohne Konto": "Du nutzt die App ohne Konto",
    "Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.": "Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.",
    "Dein Name": "Dein Name",
    "Name": "Name",
    "Name speichern": "Name speichern",
    "Passwort ändern": "Passwort ändern",
    "Aktuelles Passwort": "Aktuelles Passwort",
    "Neues Passwort": "Neues Passwort",
    "Mindestens {count} Zeichen.": "Mindestens {count} Zeichen.",
    "Neues Passwort wiederholen": "Neues Passwort wiederholen",
    "Hallo,": "Hallo,",
    "Die App ist installiert": "Die App ist installiert",
    "Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.": "Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.",
    "Zur Startseite": "Zur Startseite",
    "Direkt vom Home-Bildschirm starten": "Direkt vom Home-Bildschirm starten",
    "Im Vollbild, ohne Browserleiste": "Im Vollbild, ohne Browserleiste",
    "Gästemappe auch ohne Internet": "Gästemappe auch ohne Internet",
    "Jetzt installieren": "Jetzt installieren",
    "Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.": "Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.",
    "So geht’s in drei Schritten": "So geht’s in drei Schritten",
    "Tippe auf „Teilen“": "Tippe auf „Teilen“",
    "In Safari unten in der Leiste, in anderen Browsern oben rechts.": "In Safari unten in der Leiste, in anderen Browsern oben rechts.",
    "Wähle „Zum Home-Bildschirm“": "Wähle „Zum Home-Bildschirm“",
    "Falls du es nicht siehst, scrolle im Menü etwas nach unten.": "Falls du es nicht siehst, scrolle im Menü etwas nach unten.",
    "Tippe oben rechts auf „Hinzufügen“": "Tippe oben rechts auf „Hinzufügen“",
    "Fertig — die App liegt jetzt auf deinem Home-Bildschirm.": "Fertig — die App liegt jetzt auf deinem Home-Bildschirm.",
    "Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.": "Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.",
    "Die App ist installiert. Du findest sie jetzt auf deinem Home-Bildschirm.": "Die App ist installiert. Du findest sie jetzt auf deinem Home-Bildschirm.",
    "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.",
    "Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.": "Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.",
    "Link anfordern": "Link anfordern",
    "Zurück zur Anmeldung": "Zurück zur Anmeldung",
    "Schau in dein Postfach": "Schau in dein Postfach",
    "Der Link ist 2 Stunden gültig.": "Der Link ist 2 Stunden gültig.",
    "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.": "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.",
    "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.",
    "Passwort geändert": "Passwort geändert",
    "Dein neues Passwort ist gespeichert.": "Dein neues Passwort ist gespeichert.",
    "Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet. Melde dich mit deinem neuen Passwort an.": "Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet. Melde dich mit deinem neuen Passwort an.",
    "Neues Passwort vergeben": "Neues Passwort vergeben",
    "Wähle ein neues Passwort für dein Konto.": "Wähle ein neues Passwort für dein Konto.",
    "Passwort speichern": "Passwort speichern",
    "Du bist bereits angemeldet. Dein Passwort änderst du in den Einstellungen.": "Du bist bereits angemeldet. Dein Passwort änderst du in den Einstellungen.",
    "Dieser Link ist abgelaufen. Fordere nach dem Anmelden einen neuen an — oder registriere dich mit derselben Adresse noch einmal.": "Dieser Link ist abgelaufen. Fordere nach dem Anmelden einen neuen an — oder registriere dich mit derselben Adresse noch einmal.",
    "Wir haben dir einen neuen Link an {email} geschickt.": "Wir haben dir einen neuen Link an {email} geschickt.",
    "Link erneut senden": "Link erneut senden",
    "Benachrichtigungen sind aktiviert.": "Benachrichtigungen sind aktiviert.",
    "Benachrichtigungen konnten nicht geändert werden.": "Benachrichtigungen konnten nicht geändert werden.",
    "Auf dem iPhone kommen Benachrichtigungen nur in der installierten App an. Füge die App zuerst zum Home-Bildschirm hinzu.": "Auf dem iPhone kommen Benachrichtigungen nur in der installierten App an. Füge die App zuerst zum Home-Bildschirm hinzu.",
    "Benachrichtigungen sind für diese Seite blockiert. Du kannst sie in den Einstellungen deines Browsers wieder erlauben.": "Benachrichtigungen sind für diese Seite blockiert. Du kannst sie in den Einstellungen deines Browsers wieder erlauben.",
    "Erhalte Hinweise zu deinem Aufenthalt, Veranstaltungen und Neuigkeiten aus dem Haus.": "Erhalte Hinweise zu deinem Aufenthalt, Veranstaltungen und Neuigkeiten aus dem Haus.",
    "Du erhältst Benachrichtigungen von diesem Haus auf diesem Gerät.": "Du erhältst Benachrichtigungen von diesem Haus auf diesem Gerät.",
    "Benachrichtigungen": "Benachrichtigungen",
    "Neuigkeiten vom Gastgeber erhalten": "Neuigkeiten vom Gastgeber erhalten",
    "Unterkunft": "Unterkunft",
    "Der Wechsel hat nicht geklappt. Bitte versuche es erneut.": "Der Wechsel hat nicht geklappt. Bitte versuche es erneut.",
    "Deine Anmeldung konnte nicht übernommen werden. Bitte melde dich an.": "Deine Anmeldung konnte nicht übernommen werden. Bitte melde dich an.",
    "Seite nicht gefunden": "Seite nicht gefunden",
    "Diese Seite gibt es nicht": "Diese Seite gibt es nicht",
    "Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.": "Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.",
    "Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.": "Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.",
    "Vorschau · Entwurf — für Gäste noch nicht sichtbar": "Vorschau · Entwurf — für Gäste noch nicht sichtbar",
    "Läuft gerade": "Läuft gerade",
    "Alle Veranstaltungen der Region.": "Alle Veranstaltungen der Region.",
    "Veranstaltungen bis {km} km Entfernung.": "Veranstaltungen bis {km} km Entfernung.",
    "Nur in der Nähe anzeigen": "Nur in der Nähe anzeigen",
    "Auch weiter entfernte anzeigen": "Auch weiter entfernte anzeigen",
    "Notruf": "Notruf",
    "Feuerwehr & Rettungsdienst": "Feuerwehr & Rettungsdienst",
    "Polizei": "Polizei",
    "Hat begonnen": "Hat begonnen",
    "Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.": "Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.",
    "Eingeplant für {day}": "Eingeplant für {day}",
    "Gemerkt — noch ohne Tag.": "Gemerkt — noch ohne Tag.",
    "Findet am {day} statt": "Findet am {day} statt",
    "Termin: {day}": "Termin: {day}",
    "Tag wählen": "Tag wählen",
    "Noch ohne Tag": "Noch ohne Tag",
    "Gemerkt, noch ohne Tag": "Gemerkt, noch ohne Tag",
    "Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.": "Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.",
    "Verschoben auf {day}": "Verschoben auf {day}",
    "{day} um {time} Uhr": "{day} um {time} Uhr",
    "Termin steht fest": "Termin steht fest",
    "„{title}“ findet am {when} statt. Trotzdem auf {day} legen?": "„{title}“ findet am {when} statt. Trotzdem auf {day} legen?",
    "Trotzdem verschieben": "Trotzdem verschieben",
    "Infos zum Haus": "Infos zum Haus",
    "Mein Apartment": "Mein Apartment",
    "Service & Angebote": "Service & Angebote",
    "Rund um den Aufenthalt": "Rund um den Aufenthalt",
    "Anreise & Mobilität": "Anreise & Mobilität",
    "Sicherheit & Notfall": "Sicherheit & Notfall",
    "Konzerte & Musik": "Konzerte & Musik",
    "Party & Nachtleben": "Party & Nachtleben",
    "Feste & Festivals": "Feste & Festivals",
    "Märkte": "Märkte",
    "Shows & Performances": "Shows & Performances",
    "Comedy & Kabarett": "Comedy & Kabarett",
    "Film & Kino": "Film & Kino",
    "Ausstellungen & Kunst": "Ausstellungen & Kunst",
    "Lesungen & Literatur": "Lesungen & Literatur",
    "Vorträge & Bildung": "Vorträge & Bildung",
    "Führungen & Touren": "Führungen & Touren",
    "Sport & Bewegung": "Sport & Bewegung",
    "Kinder & Familie": "Kinder & Familie",
    "Essen & Trinken": "Essen & Trinken",
    "Workshops & Kurse": "Workshops & Kurse",
    "Brauchtum & Tradition": "Brauchtum & Tradition",
    "Concierge von {house}": "Concierge von {house}",
    "Willkommen im {house}! Ich bin der digitale Concierge und beantworte deine Fragen rund um den Aufenthalt — jederzeit. Für alles andere leite ich dich gern an deine Gastgeber weiter.": "Willkommen im {house}! Ich bin der digitale Concierge und beantworte deine Fragen rund um den Aufenthalt — jederzeit. Für alles andere leite ich dich gern an deine Gastgeber weiter.",
    "KI": "KI",
    "Check-in & Ankommen": "Check-in & Ankommen",
    "{address} in Google Maps öffnen": "{address} in Google Maps öffnen"
}
